import { render, staticRenderFns } from "./APIControls.vue?vue&type=template&id=0bc95478&scoped=true&"
import script from "./APIControls.vue?vue&type=script&lang=js&"
export * from "./APIControls.vue?vue&type=script&lang=js&"
import style0 from "./APIControls.vue?vue&type=style&index=0&id=0bc95478&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc95478",
  null
  
)

export default component.exports